export default "__VITE_ASSET__CUCnqfly__"